import React, { useState, useEffect, useRef } from 'react'
import { useDispatch, connect } from 'react-redux'
import AddContract from './add'
import AddPendingUniContract from './addPendingUni'
import EditPendingUniContract from './editPendingUniversityContract'
import { TableComp } from 'sz-react-utils-lite'
import lodash from 'lodash'
import {
  countryIds,
  DefaultTablePagination,
  displayDate, filterOption, InputBox
} from '../../../components/_utils/appUtils'
import {
  getContractGroups,
  listAllPendingContractFxn
} from '../actions/contract'
import { Button, Col, Icon, Input, Row, Select, Tooltip } from 'antd'
import _ from 'lodash'
import { listAllCountries } from '../../countries/actions/countries'
import moment from 'moment'
import { getUrlPushWrapper } from '../../../routes/routes'
import { listWithdrawalFxn } from '../../withdrawal/actions/withdrawalAction'
import { listAllUniversities, listQuickSearchUniversities } from '../../university/actions/university'

const universityTypeList = [
  { name: 'Already Added in Portal', value: 'alreadyAdded' },
  { name: 'Not Added in Portal', value: 'other' }
]
let initFilter = {
  countryId: undefined,
  universityName: undefined
}
const { Option } = Select
const PendingUniversityContract = (props) => {
  const tableRef = useRef()
  const dispatch = useDispatch()
  let [totalRecord, setTotalRecord] = useState(0)
  const [itemNo, setItemNo] = useState(1)
  const [addContractVisible, setAddContractVisible] = useState(false)
  const [pendingUniDrawer, setPendingUniDrawer] = useState(false)
  const [editUniDrawer, setEditUniDrawer] = useState(false)
  const [contractId, setContractId] = useState('')
  const [pendingContractData, setPendingContractData] = useState()
  const [groupData, setGroupData] = useState([])
  const [countryId, setCountryId] = useState('')
  const [contractWith, setContractWith] = useState([])
  const [countryList, setCountryList] = useState([])
  let [filterState, setFilterState] = useState(initFilter)
  const loadCountryList = async () => {
    let params = {
      results: 5000,
      select: ['countryName'],
      sortField: 'countryName',
      sortOrder: 'ascend'
    }
    let { data } = await dispatch(listAllCountries(params))
    if (data && data.length) {
      setCountryList(data)
    }
  }
  const events = {
    hideDrawer: () => {
      setAddContractVisible(false)
      tableRef.current.reload()
    },
    _updateFilter: (data) => {
      setFilterState((prevState) => {
        return {
          ...prevState,
          ...data
        }
      })
    },
    hidePendingUniDrawer: () => {
      setPendingUniDrawer(false)
      tableRef.current.reload()
    },
    hideEditPendingUniDrawer: () => {
      setEditUniDrawer(false)
      tableRef.current.reload()
    },
    searchFxn: () => {
      setTimeout(() => {
        tableRef.current.reload()
      }, 500)
    },
    clearFxn: () => {
      events._updateFilter(initFilter)
      setTimeout(() => {
        tableRef.current.reload()
      }, 500)
    },
    getParamsForApplicationList: () => {
      return new Promise(resolve => {
        let obj = {}
        lodash.each(initFilter, (item, key) => {
          if (filterState[key]) {
            obj[key] = filterState[key]
          }
        })

        resolve(obj)
      })
    }
  }


  const apiRequest = (params) => {
    return new Promise(async (resolve) => {
      let filterResp = await events.getParamsForApplicationList()
      params = { ...params, ...filterResp }
      params.sortField = '_id'
      params.sortOrder = 'descend'
      let resp = await dispatch(listAllPendingContractFxn({ ...params, regExFilters: ['universityName'] }))
      if (resp && resp.total) {
        setTotalRecord(resp.total)
      }
      resolve(resp)
    })
  }
  const getContractWithGroups = async (params = {}) => {
    let respData = await dispatch(getContractGroups({
      ...params
    }))
    let { contractWith } = respData
    setContractWith(contractWith)
    let cloneDoc = _.clone(contractWith)
    _.each(cloneDoc, (item) => {
      let findVal = _.find(respData.data, (doc) => {
        return doc._id == item.name
      })
      if (findVal) {
        item.value = findVal.count
      }
    })
    setGroupData(cloneDoc)
  }

  useEffect(() => {

    loadCountryList()

  }, [])


  useEffect(() => {
    getContractWithGroups()
  }, [])

  const columns = [
    {
      title: 'S.No',
      dataIndex: 'sno',
      width: 50,
      key: 'sno',
      render: (item, record, index) => {
        return (
          <a className={'linkPointer'}>
            {(itemNo - 1) * 10 + index + 1}
          </a>
        )
      }
    },
    {
      title: 'Status',
      key: 'status',
      dataIndex: 'status',
      width: 100,
      render: (item) => {
        return (
          <div className={'alignCenter'}>
            {item == 'Pending' ?
              <div className={'label label-warning sm'}>
                {item}
              </div> :
              <div className={'label label-success sm'}>
                {item}
              </div>
            }
          </div>
        )
      }
    },
    {
      title: 'Country',
      dataIndex: 'countryId',
      key: 'countryId',
      width: 100,
      render: (item) => {
        return (
          item && item.countryName ? item.countryName : ''
        )
      }
    },
    {
      title: 'University',
      dataIndex: 'universityType',
      key: 'universityType',
      width: 300,
      render: (item, record) => {
        let { universityId, universityName } = record
        return (
          <div>
            {item == 'alreadyAdded' && universityId && universityId.universityName ? universityId.universityName : null}
            {item == 'other' && universityName ? universityName : null}
          </div>
        )
      }
    },
    {
      title: 'Campus City',
      key: 'universityCity',
      dataIndex: 'universityCity',
      width: 200
    },
    {
      title: 'Expected Date',
      dataIndex: 'expectedDate',
      key: 'expectedDate',
      width: 120,
      render: (item) => {
        return (
          item ? displayDate(item) : ''
        )
      }
    },
    {
      title: 'Details',
      key: 'details',
      dataIndex: 'details'
    },
    {
      title: 'Actions',
      dataIndex: 'actions',
      width: 170,
      render: (_, record) => {
        let { status } = record
        return (
          <div className={'btn_group'}>
            {status == 'Pending' ?
              <Tooltip title='Convert Contract'>
                <a className={'btn btn-default roundNew sm'} onClick={() => {
                  setAddContractVisible(true)
                  setContractId(record._id)
                  setPendingContractData(record)
                }}>
                  Convert
                </a>
              </Tooltip> : null}
            <Tooltip title='Edit Contract'>
              <a className={'btn btn-default roundNew sm'} onClick={() => {
                setEditUniDrawer(true)
                setContractId(record._id)
                setPendingContractData(record)
              }}>
                Edit
              </a>
            </Tooltip>
          </div>
        )
      }
    }
  ]
  const filterBlock = (
    <Row gutter={16} className={'filter_box'}>
      <Col md={4} sm={4} xs={8} lg={4}>
        <InputBox title={'Country'}>
          <Select
            name='Search By Country'
            onChange={item => {
              setCountryId(item)
              events._updateFilter({ countryId: item })
            }}
            filterOption={filterOption}
            className=''
            placeholder='Country'
            allowClear
            showSearch
            value={filterState.countryId || undefined}>
            {countryList.map((item, key) => (
              <Option value={item._id} key={key}>
                {item.countryName}
              </Option>
            ))}
          </Select>
        </InputBox>

      </Col>


      <Col md={4} sm={4} xs={8} lg={4}>
        <InputBox title={'University'}>
          <input
            placeholder={'Search By University'}
            name='Search By University'
            onChange={({ target }) => {
              events._updateFilter({ universityName: target.value })
            }}
            value={filterState.universityName}
          />
        </InputBox>
      </Col>

      <Col md={24} sm={24} xs={24} lg={24}>
        <div className={'btn_group'}>
          <a className={'default_btn'} onClick={events.searchFxn}>Search</a>
          <a className={'default_btn'} onClick={events.clearFxn}>Clear</a>
        </div>
      </Col>
    </Row>
  )

  return (
    <div className='row mt-4'>
      <div className='col-lg-12'>
        <div className='card reportContainer'>
          <div className='table-head d-flex align-items-center'>
            <h5>All Pending University Contract: ({totalRecord})</h5>
            <div className='search-box-table'>
            </div>
            <div className='sort-box-table mark-btn'>
              <button
                className='btn'
                onClick={() => setPendingUniDrawer(true)}
              >
                <img src={'../dist/icons/plus.png'} className={'plus'} />
                Add Pending University Contract
              </button>
            </div>

          </div>
          <div className='card-body table-responsive'>
            {filterBlock}
            <TableComp columns={columns}
                       apiRequest={apiRequest}
                       ref={tableRef}
                       pagination={DefaultTablePagination()}
            />
          </div>
        </div>
      </div>
      {addContractVisible ?
        <AddContract
          data={pendingContractData}
          visible={addContractVisible}
          universityTypeList={universityTypeList}
          contractWith={contractWith}
          events={events}
        /> : ''}

      {pendingUniDrawer ?
        <AddPendingUniContract
          visible={pendingUniDrawer}
          universityTypeList={universityTypeList}
          events={events}
          id={contractId}
        /> : ''}
      {editUniDrawer ?
        <EditPendingUniContract
          visible={editUniDrawer}
          universityTypeList={universityTypeList}
          events={events}
          id={contractId}
          data={pendingContractData}
        /> : ''}
    </div>
  )
}
export default connect(
)(PendingUniversityContract)
